import { ContactClassifier } from '../../../constants'
import { ClassifierFieldProps } from '../ClassifierFields'


export const SENTIMENT_CLASSIFIER_KEY = [
  { id: 1, name: 'sentiment_negative' },
  { id: 2, name: 'sentiment_neutral' },
  { id: 3, name: 'sentiment_positive' },
] as const

export const REASON_CLASSIFIER_KEY = [
  { id: 1, name: 'firstCallofDay' },
  { id: 2, name: 'lastCallofDay' },
  { id: 3, name: 'longestCallofDay' },
  { id: 4, name: 'shortestCallofDay' },
  { id: 5, name: 'randomCallofDay' },
  { id: 6, name: 'rec_reason_what_new_emp' },
  { id: 7, name: 'rec_reason_what_performance' },
  { id: 8, name: 'rec_reason_what_logging' },
  { id: 9, name: 'tagged' },
  { id: 10, name: 'rec_reason_archive' },
  { id: 11, name: 'rec_reason_analytics_tagged' },
  { id: 12, name: 'rec_reason_mark_quality' },
  { id: 13, name: 'rec_reason_noncall' },
  { id: 14, name: 'rec_reason_tagged_archive' },
  { id: 15, name: 'rec_reason_survey_kpi' },
  { id: 16, name: 'rec_reason_untagged' },
  { id: 17, name: 'rec_reason_untagged_archive' },
  { id: 18, name: 'rec_reason_api_imported' },
] as const

export interface FieldProps extends ClassifierFieldProps {
  classifier: ContactClassifier,
}
